import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NbAutocompleteModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDatepickerModule,
  NbIconModule,
  NbInputModule,
  NbNativeDateService,
  NbPopoverModule,
  NbSelectModule,
  NbTooltipModule,
} from '@nebular/theme';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GenericTableComponent } from './generic-table.component';
import { SortDirective } from '../types/sort.directive';
import { DynamicContentComponent } from '../dinamic-content/dynamic-content-component';
import { HostDirective } from '../dinamic-content/host.directive';
import { NbEvaIconsModule } from '@nebular/eva-icons';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NbButtonModule,
    NbInputModule,
    NbSelectModule,
    NgbModule,
    ReactiveFormsModule,
    NbAutocompleteModule,
    NbDatepickerModule,
    NbPopoverModule,
    NbBadgeModule,
    NbEvaIconsModule,
    NbIconModule,
    NbCheckboxModule,
    NbTooltipModule,
    NbCardModule,
    SortDirective,
    HostDirective
  ],
  providers: [
    NbNativeDateService
  ],
  exports: [
    GenericTableComponent, 
    SortDirective, 
    DynamicContentComponent,
    HostDirective,
  ],
  declarations: [
    GenericTableComponent, 
    DynamicContentComponent,
  ],
})
export class GenericTableModule {}
